import React, { useState, useEffect, useRef } from 'react'
import './Homepage.css'
import TopBar from '../components/TopBar'
import Footer from '../components/Footer'

import TopImg from '../assets/homepage-top.webp'
import TopImg2 from '../assets/homepage-top2.webp'
import TopImg3 from '../assets/homepage-top3.webp'
import Comp1 from '../assets/Comp1.png'
import Comp2 from '../assets/Comp2.png'
import Comp3 from '../assets/Comp3.png'
import Comp24 from '../assets/Comp4.png'
import Comp210 from '../assets/Comp5.png'
import Comp6 from '../assets/megasigorta.svg'
import Comp7 from '../assets/agroup_1_e32fd7586b.svg'
import Comp8 from '../assets/Comp8.png'


import Comp21 from '../assets/Comp21.svg'
import Comp22 from '../assets/Comp22.png'
import Comp211 from '../assets/Comp23.png'
import Comp4 from '../assets/Comp24.png'
import Comp25 from '../assets/Comp25.png'
import Comp26 from '../assets/Comp26.png'
import Comp27 from '../assets/Comp27.webp'
import Comp28 from '../assets/Comp28.webp'

import Comp29 from '../assets/Comp29.png'
import Comp5 from '../assets/Comp210.png'
import Comp23 from '../assets/Comp211.webp'
import Comp212 from '../assets/Comp212.png'
import Comp213 from '../assets/Comp213.webp'
import Comp214 from '../assets/Comp214.png'
import Comp215 from '../assets/Comp215.png'
import Comp216 from '../assets/Comp216.webp'

import Chevron from '../assets/Chevron Right.svg'
import Img1 from '../assets/img1png.webp'
import Img2 from '../assets/img2.webp'
import Img3 from '../assets/img3.webp'
import Q1 from '../assets/Quote.svg'
import Q2 from '../assets/Quote2.svg'
import Q3 from '../assets/Quote3.svg'
import QuoteBackground from '../assets/Quote-background.svg';
import QuoteSymbol from '../assets/Quote-symbol.svg';

import Post1 from '../assets/Post1.webp'
import Post2 from '../assets/Post2.webp'

import Post3 from '../assets/Post3.webp'
import Loader from '../components/Loader'
import { motion as m } from "framer-motion";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import ReactCardFlip from 'react-card-flip'

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(useGSAP);

const Homepage = () => {
    
  const { i18n } = useTranslation();
  const { t } = useTranslation();

  
  const addHtml1 = t('TopPic3pc');
  const addHtml2 = t('About3pc');
  const addHtml3 = t('AboutP1pc');
  const addHtml4 = t('AboutP2pc');
  const addHtml5 = t('AboutP3pc');
  const addHtml6 = t('Company5');
  const addHtml7 = t('Offer2pc');
  const addHtml8 = t('TopPic3dev');

  
    //media query
    const [deviceWidth, setDeviceWidth] = useState(window.screen.width);

    //companies local/global switch
    const [isLocal, setIsLocal] = useState(true);
    const switchRef = useRef(null);

    
    const [isFlipped, setIsFlipped]=useState(false);
    useEffect(() => {
        if (isLocal) {
          const interval = setInterval(() => {
            setIsFlipped(prev => !prev);
          }, 3000); // Toggle every 5 seconds
      
          return () => clearInterval(interval);
        }
      }, [isLocal]);


    const localRef0 = useRef();
    const globalRef0 = useRef();
    let component = useRef();

    useEffect(() => {
        // Animate Local text color
        gsap.to(localRef0.current, {
            color: isLocal ? '#FFF' : '#000',  // White when local, black otherwise
            duration: 0.5,
            ease: 'power1.out',
        });

        // Animate Global text color
        gsap.to(globalRef0.current, {
            color: isLocal ? '#000' : '#FFF',  // Black when local, white otherwise
            duration: 0.5,
            ease: 'power1.out',
        });
    }, [isLocal]);

    const companiesRef = useRef(null); // Ref for the container of company elements
    useEffect(() => {
        // Setting the initial state of the company elements.  
        gsap.set(companiesRef.current?.children, { autoAlpha: isLocal ? 1 : 0 });
    }, [isLocal]);

    useGSAP(() => {
        const tl = gsap.timeline({ defaults: { ease: 'power1.inOut' } });

        if (switchRef.current) {
            tl.set(switchRef.current, {
                x: isLocal ? '0%' : '100%',
                backgroundColor: 'black',
                color: isLocal ? 'white' : 'black',
            });
        }
    }, [isLocal]);

    const toggle = () => {

        const currentClass = isLocal ? '.local' : '.global';
        const nextClass = isLocal ? '.global' : '.local';
        gsap.set([currentClass, nextClass], { position: 'absolute', });


        // Animation timeline
        const t2 = gsap.timeline({
            defaults: { ease: 'back.in' },
            onStart: () => {
                gsap.set(nextClass, {
                    display: 'block',
                    x: '100%', // Positioned off-screen right
                    autoAlpha: 0 // Start transparent
                });
            }
        });

        t2.to(currentClass, {
            x: '-100%', // Move to the left
            autoAlpha: 0, // Fade out
            duration: 0.5,
            onComplete: () => {
                // Hide after animation
                gsap.set(currentClass, {
                    display: 'none',
                    clearProps: "position,opacity,transform"
                });
            }
        })
            .add(() => {
                // Animate next elements in from the right
                gsap.to(nextClass, {
                    x: '0%', // Center on screen
                    autoAlpha: 1, // Fade in
                    duration: 0.5
                });

                // Toggle state only after animations
                setIsLocal(!isLocal);
            });


        const tl = gsap.timeline({ defaults: { ease: 'power1.inOut' } });
        tl.to(switchRef.current, {
            x: !isLocal ? '0%' : '100%',
            duration: 0.5,
            onStart: () => {
                gsap.to(switchRef.current, {

                    color: !isLocal ? 'white' : 'black',
                    duration: 0.25
                });
            },
        });


    };


    //mobile companies scroll 
    const scrollContainer = useRef(null);
    const [direction, setDirection] = useState(1); // 1 for right, -1 for left
    const [scrollAmount, setScrollAmount] = useState(0);
    const [isPaused, setIsPaused] = useState(false);

    function animateScroll() {
        // Initialize frameCount outside the function to keep its state across frames
        let frameCount = 0;

        function scroll() {
            if (scrollContainer.current && !isPaused) {
                const maxScrollLeft = scrollContainer.current.scrollWidth - scrollContainer.current.clientWidth;
                if ((scrollAmount >= maxScrollLeft && direction === 1) || (scrollAmount <= 0 && direction === -1)) {
                    setIsPaused(true);
                    setTimeout(() => {
                        setDirection(direction => -direction);
                        setIsPaused(false);
                    }, 1000); // Delay of 1 second before switching direction
                    return;
                }

                const newScrollAmount = scrollAmount + direction * 1.5; // Adjusting for slower speed
                scrollContainer.current.scrollLeft = newScrollAmount;

                // Only update state every 10 frames

                setScrollAmount(newScrollAmount);

                frameCount++; // Increment frame count
            }
            requestAnimationFrame(scroll);
        }

        // Start the animation loop
        requestAnimationFrame(scroll);
    }

    useEffect(() => {
        let animationFrameId = requestAnimationFrame(animateScroll);
        return () => cancelAnimationFrame(animationFrameId);
    }, [scrollAmount, direction, isPaused]);



    //parallax section
    const topRef = useRef(null);
    const aboutRef = useRef(null);
    const companiesSectionRef = useRef(null);
    const offersSectionRef = useRef(null);


    useEffect(() => {
        const handleResize = () => {
            setDeviceWidth(window.screen.width);
        };
        window.addEventListener('resize', handleResize);
        window.addEventListener('orientationchange', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('orientationchange', handleResize);
        };
    }, []);

    //top image
    var tImage;
    if (deviceWidth > 1023) {
        tImage = TopImg;
    }
    else if (deviceWidth > 767 && deviceWidth < 1024) {
        tImage = TopImg2;
    }
    else if (deviceWidth < 768) {
        tImage = TopImg3;
    }

    //more refs for gsap
    const topTextRef1 = useRef(null);
    const topTextRef2 = useRef(null);
    const bottomTextRef = useRef(null);
    const count1Ref = useRef(null);
    const count2Ref = useRef(null);
    const count3Ref = useRef(null);

    const about1Ref = useRef(null);
    const about2Ref = useRef(null);
    const about3Ref = useRef(null);

    const backgroundImageRef = useRef(null); // The ref for the background image
    const textRef = useRef(null); // The ref for the text container

    useGSAP(() => {
        // Register the plugin
        gsap.registerPlugin(ScrollTrigger);

        // Runs once on mount. On a first visit this plays out behind the splash Loader,
        // so when the Loader fades the page is simply already there — nothing re-animates.
        gsap.from([topTextRef1.current, topTextRef2.current, bottomTextRef.current], {
            opacity: 0,
            y: "+=30",
            delay: 0.5,
            ease: "sine.out",
        });



    }, []);


    ///////////////////HOME PAGE HEADER TOP STICKY ELEMENT
    useEffect(() => {

        let ctx = gsap.context(() => {
            gsap.to(".Homepage-top-img", {
                scrollTrigger: {
                    trigger: "#homepage__header",
                    start: "top top",
                    end: "bottom bottom",
                    scrub: true,
                },
                maxWidth: "100%",
                height: "100%",
                borderRadius: "0%",
                scrub: true
            });

            ScrollTrigger.create({
                trigger: ".Homepage-top",
                pin: '.homepage-header-img__wrapper',
                start: "top top",
            })

        }, component);
        return () => ctx.revert();
    }, [])


    //quote changer
    const [currentQuoteIndex, setCurrentQuoteIndex] = useState(0);
  const [animationClass, setAnimationClass] = useState('fade-in'); // Animation state

  const quotes = [
    { quoteKey: "Quote1", authorKey: "Quote2" },
    { quoteKey: "Quote3", authorKey: "Quote4" },
    { quoteKey: "Quote5", authorKey: "Quote6" },
    { quoteKey: "Quote7", authorKey: "Quote8" },
    { quoteKey: "Quote9", authorKey: "Quote10" },
    { quoteKey: "Quote11", authorKey: "Quote12" },
    { quoteKey: "Quote13", authorKey: "Quote14" },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimationClass('fade-out'); // Trigger fade-out animation
      setTimeout(() => {
        setCurrentQuoteIndex((prevIndex) => (prevIndex + 1) % quotes.length);
        setAnimationClass('fade-in'); // Trigger fade-in animation
      }, 500); // Match this to fade-out duration in CSS
    }, 7000); // Change every 10 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, [quotes.length]);

  const currentQuote = quotes[currentQuoteIndex];

    return (
        <m.div
            className="Homepage"
            ref={component}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: .25 }}
        >
        
            {/* Break */}
            <section className="Homepage-top" id='homepage__header' ref={topRef}>
                <div className="homepage-header-img__wrapper">
                    <div ref={backgroundImageRef}
                        // style={{ backgroundImage: `url(${tImage})` }}
                        className="Homepage-top-img"
                    >
                        <img loading="lazy" decoding="async" src={TopImg} alt="" className='homepage-header__image' />
                        <div ref={textRef} className="Homepage-top-text">
                            <div className="Homepage-dummy">
                                <p ref={topTextRef1} className="Homepage-top-text-top1">{t('TopPic1')}</p>
                                <p ref={topTextRef2} className="Homepage-top-text-top2">{t('TopPic2')}</p>
                            </div> {deviceWidth > 767 &&
                                <p ref={bottomTextRef} className="Homepage-top-text-bottom" dangerouslySetInnerHTML={{ __html: addHtml1 }}></p>}
                            {deviceWidth < 768 &&
                                <p ref={bottomTextRef} className="Homepage-top-text-bottom"  dangerouslySetInnerHTML={{ __html: addHtml8 }}></p>}
                        </div>
                    </div>
                </div>
            </section>
            {/* Break */}
            
            {/*section className="Homepage-about" ref={aboutRef}>
                <div className="homepage-about__inner">
                    <div className="Homepage-about-top">
                        <p ref={about1Ref} className="Homepage-about-top-header">{t('About1')}</p>
                        <div className="Homepage-about-top-text">
                            <p ref={about2Ref} className="Homepage-about-top-text-top">{t('About2')}</p>
                            {deviceWidth > 767 && <p ref={about3Ref} className="Homepage-about-top-text-bottom" dangerouslySetInnerHTML={{ __html: addHtml2 }}></p>}
                            {deviceWidth < 768 && <p ref={about3Ref} className="Homepage-about-top-text-bottom" dangerouslySetInnerHTML={{ __html: addHtml2 }}></p>}
                        </div>
                    </div>
                    {/*<div className="Homepage-about-bottom">
                        <div className="Homepage-about-bottom-element">
                            <p ref={count1Ref} className="Homepage-about-bottom-element-left">1M+</p>
                            {deviceWidth > 767 && <p className="Homepage-about-bottom-element-right" dangerouslySetInnerHTML={{ __html: addHtml3 }}></p>}
                            {deviceWidth < 768 && <p className="Homepage-about-bottom-element-right">{t('AboutP1dev')}</p>}
                        </div>
                        <div className="Homepage-about-bottom-element">
                            <p ref={count2Ref} className="Homepage-about-bottom-element-left">93%</p>
                            {deviceWidth > 767 && <p className="Homepage-about-bottom-element-right" dangerouslySetInnerHTML={{ __html: addHtml4 }}></p>}
                            {deviceWidth < 768 && <p className="Homepage-about-bottom-element-right">{t('AboutP2dev')}</p>}
                        </div>
                        <div className="Homepage-about-bottom-element">
                            <p ref={count3Ref} className="Homepage-about-bottom-element-left">4.9</p>
                            {deviceWidth > 767 && <p className="Homepage-about-bottom-element-right" dangerouslySetInnerHTML={{ __html: addHtml5 }}></p>}
                            {deviceWidth < 768 && <p className="Homepage-about-bottom-element-right">{t('AboutP3dev')}</p>}
                        </div>
                            </div>}
                </div>
            </section>*/}
            
            {/* Break */}
            <section className='Homepage-offer' ref={offersSectionRef}>
                <div className="Homepage-offer-title">
                    <p className="Homepage-offer-title-top">{t('Offer1')}</p>
                    {deviceWidth > 767 && <p className="Homepage-offer-title-bottom" dangerouslySetInnerHTML={{ __html: addHtml7 }}></p>}
                    {deviceWidth < 768 && <p className="Homepage-offer-title-bottom">{t('Offer2dev')}</p>}
                </div>
                <div className="Homepage-offer-content">{deviceWidth > 1023 && <>
                    <div className="Homepage-offer-content-row">
                        <div className="Homepage-offer-content-row-element">
                            <div className="Homepage-offer-content-row-element-left">
                                <p className="Homepage-offer-content-row-element-left-number">1</p>
                            </div>
                            <div className="Homepage-offer-content-row-element-right">
                                <p className="Homepage-offer-content-row-element-right-top">{t("Offer3")}</p>
                                <p className="Homepage-offer-content-row-element-right-bottom">{t("Offer4")}</p>
                            </div>
                        </div>
                        <div className="Homepage-offer-content-row-element">
                            <div className="Homepage-offer-content-row-element-left">
                                <p className="Homepage-offer-content-row-element-left-number">2</p>
                            </div>
                            <div className="Homepage-offer-content-row-element-right">
                                <p className="Homepage-offer-content-row-element-right-top">{t("Offer5")}</p>
                                <p className="Homepage-offer-content-row-element-right-bottom">{t("Offer6")}</p>
                            </div>
                        </div>
                    </div>
                    <div className="Homepage-offer-content-row">
                        <div className="Homepage-offer-content-row-element">
                            <div className="Homepage-offer-content-row-element-left">
                                <p className="Homepage-offer-content-row-element-left-number">3</p>
                            </div>
                            <div className="Homepage-offer-content-row-element-right">
                                <p className="Homepage-offer-content-row-element-right-top">{t("Offer7")}</p>
                                <p className="Homepage-offer-content-row-element-right-bottom">{t("Offer8")}</p>
                            </div>
                        </div>
                        <div className="Homepage-offer-content-row-element">
                            <div className="Homepage-offer-content-row-element-left">
                                <p className="Homepage-offer-content-row-element-left-number">4</p>
                            </div>
                            <div className="Homepage-offer-content-row-element-right">
                                <p className="Homepage-offer-content-row-element-right-top">{t("Offer9")}</p>
                                <p className="Homepage-offer-content-row-element-right-bottom">{t("Offer10")}</p>
                            </div>
                        </div>
                    </div>
                    <div className="Homepage-offer-content-row">
                        <div className="Homepage-offer-content-row-element">
                            <div className="Homepage-offer-content-row-element-left">
                                <p className="Homepage-offer-content-row-element-left-number">5</p>
                            </div>
                            <div className="Homepage-offer-content-row-element-right">
                                <p className="Homepage-offer-content-row-element-right-top">{t("Offer11")}</p>
                                <p className="Homepage-offer-content-row-element-right-bottom">{t("Offer12")}</p>
                            </div>
                        </div>
                        <div className="Homepage-offer-content-row-element">
                            <div className="Homepage-offer-content-row-element-left">
                                <p className="Homepage-offer-content-row-element-left-number">6</p>
                            </div>
                            <div className="Homepage-offer-content-row-element-right">
                                <p className="Homepage-offer-content-row-element-right-top">{t("Offer13")}</p>
                                <p className="Homepage-offer-content-row-element-right-bottom">{t("Offer14")}</p>
                            </div>
                        </div>
                    </div>
                    <div className="Homepage-offer-content-row">
                        <div className="Homepage-offer-content-row-element">
                            <div className="Homepage-offer-content-row-element-left">
                                <p className="Homepage-offer-content-row-element-left-number">7</p>
                            </div>
                            <div className="Homepage-offer-content-row-element-right">
                                <p className="Homepage-offer-content-row-element-right-top">{t("Offer15")}</p>
                                <p className="Homepage-offer-content-row-element-right-bottom">{t("Offer16")}</p>
                            </div>
                        </div>
                        <div className="Homepage-offer-content-row-element">
                            <div className="Homepage-offer-content-row-element-left">
                                <p className="Homepage-offer-content-row-element-left-number">8</p>
                            </div>
                            <div className="Homepage-offer-content-row-element-right">
                                <p className="Homepage-offer-content-row-element-right-top">{t("Offer17")}</p>
                                <p className="Homepage-offer-content-row-element-right-bottom">{t("Offer18")}</p>
                            </div>
                        </div>
                    </div>
                </>}
                    {deviceWidth < 1024 &&
                        <>
                            <div className="Homepage-offer-content-row-element">
                                <div className="Homepage-offer-content-row-element-left">
                                    <p className="Homepage-offer-content-row-element-left-number">1</p>
                                </div>
                                <div className="Homepage-offer-content-row-element-right">
                                    <p className="Homepage-offer-content-row-element-right-top">{t("Offer3")}</p>
                                    <p className="Homepage-offer-content-row-element-right-bottom">{t("Offer4")}</p>
                                </div>
                            </div> 
                            <div className="Homepage-offer-content-row-element">
                                <div className="Homepage-offer-content-row-element-left">
                                    <p className="Homepage-offer-content-row-element-left-number">2</p>
                                </div>
                                <div className="Homepage-offer-content-row-element-right">
                                    <p className="Homepage-offer-content-row-element-right-top">{t("Offer5")}</p>
                                    <p className="Homepage-offer-content-row-element-right-bottom">{t("Offer6")}</p>
                                </div>
                            </div> 
                            <div className="Homepage-offer-content-row-element">
                                <div className="Homepage-offer-content-row-element-left">
                                    <p className="Homepage-offer-content-row-element-left-number">3</p>
                                </div>
                                <div className="Homepage-offer-content-row-element-right">
                                    <p className="Homepage-offer-content-row-element-right-top">{t("Offer7")}</p>
                                    <p className="Homepage-offer-content-row-element-right-bottom">{t("Offer8")}</p>
                                </div>
                            </div>
                            <div className="Homepage-offer-content-row-element">
                                <div className="Homepage-offer-content-row-element-left">
                                    <p className="Homepage-offer-content-row-element-left-number">4</p>
                                </div>
                                <div className="Homepage-offer-content-row-element-right">
                                    <p className="Homepage-offer-content-row-element-right-top">{t("Offer9")}</p>
                                    <p className="Homepage-offer-content-row-element-right-bottom">{t("Offer10")}</p>
                                </div>
                            </div>
                            <div className="Homepage-offer-content-row-element">
                                <div className="Homepage-offer-content-row-element-left">
                                    <p className="Homepage-offer-content-row-element-left-number">5</p>
                                </div>
                                <div className="Homepage-offer-content-row-element-right">
                                    <p className="Homepage-offer-content-row-element-right-top">{t("Offer11")}</p>
                                    <p className="Homepage-offer-content-row-element-right-bottom">{t("Offer12")}</p>
                                </div>
                            </div> 
                            <div className="Homepage-offer-content-row-element">
                                <div className="Homepage-offer-content-row-element-left">
                                    <p className="Homepage-offer-content-row-element-left-number">6</p>
                                </div>
                                <div className="Homepage-offer-content-row-element-right">
                                    <p className="Homepage-offer-content-row-element-right-top">{t("Offer13")}</p>
                                    <p className="Homepage-offer-content-row-element-right-bottom">{t("Offer14")}</p>
                                </div>
                            </div> 
                            <div className="Homepage-offer-content-row-element">
                                <div className="Homepage-offer-content-row-element-left">
                                    <p className="Homepage-offer-content-row-element-left-number">7</p>
                                </div>
                                <div className="Homepage-offer-content-row-element-right">
                                    <p className="Homepage-offer-content-row-element-right-top">{t("Offer15")}</p>
                                    <p className="Homepage-offer-content-row-element-right-bottom">{t("Offer16")}</p>
                                </div>
                            </div>
                            <div className="Homepage-offer-content-row-element">
                                <div className="Homepage-offer-content-row-element-left">
                                    <p className="Homepage-offer-content-row-element-left-number">8</p>
                                </div>
                                <div className="Homepage-offer-content-row-element-right">
                                    <p className="Homepage-offer-content-row-element-right-top">{t("Offer17")}</p>
                                    <p className="Homepage-offer-content-row-element-right-bottom">{t("Offer18")}</p>
                                </div>
                            </div>
                        </>
                    } </div>
            </section>
            {/* Break */}
            <section className="Homepage-companies" ref={companiesSectionRef}>
                <div className="Homepage-companies-left">{deviceWidth > 1023 && <>
                    <div className='Homepage-companies-left-top' onClick={toggle}>
                        <div ref={localRef0} className='Homepage-companies-left-top-text'>{t('Company1')}</div>
                        <div ref={globalRef0} className='Homepage-companies-left-top-text'>{t('Company2')}</div>
                        <div className='Homepage-companies-left-top-selected' ref={switchRef}></div>
                    </div>
                    <div className='Homepage-companies-left-bottom'>
                        <p className="Homepage-companies-left-bottom-header">{t('Company3')}</p>
                        <div className="Homepage-companies-left-bottom-text">
                            <p className="Homepage-companies-left-bottom-text-top">{t('Company4')}</p>
                            <p className="Homepage-companies-left-bottom-text-bottom" dangerouslySetInnerHTML={{ __html: addHtml6 }}></p>
                        </div>
                    </div></>}
                    {deviceWidth < 1024 &&
                        <>
                            <div className='Homepage-companies-left-bottom'>
                                <p className="Homepage-companies-left-bottom-header">{t('Company3')}</p>

                                <p className="Homepage-companies-left-bottom-text-top">{t('Company4')}</p>

                            </div>
                            <div className='Homepage-companies-left-top' onClick={toggle}>
                                <div ref={localRef0} className='Homepage-companies-left-top-text'>{t('Company1')}</div>
                                <div ref={globalRef0} className='Homepage-companies-left-top-text'>{t('Company2')}</div>
                                <div className='Homepage-companies-left-top-selected' ref={switchRef}></div>
                            </div>
                        </>
                    }
                </div>
                {deviceWidth > 767 && <div className="Homepage-companies-right" style={{ position: 'relative' }} ref={companiesRef}>
                    <div className='local'> {<ReactCardFlip flipDirection='horizontal' isFlipped={isFlipped} >
                    <div key="front">
                        <div className="Homepage-companies-right-element" style={{ marginLeft: '17.4px', marginBottom: '8px' }}>
                            <div className="Homepage-companies-right-element-1">
                                <img loading="lazy" decoding="async" alt=""  src={Comp1} />
                            </div>
                            <div className="Homepage-companies-right-element-2">
                                <img loading="lazy" decoding="async" alt="" src={Comp2} />
                            </div>
                        </div>
                        <div className="Homepage-companies-right-element" style={{ marginLeft: '45.1px', marginBottom: '8px' }}>
                            <div className="Homepage-companies-right-element-3">
                                <img loading="lazy" decoding="async" alt="" src={Comp3} />
                            </div>
                            <div className="Homepage-companies-right-element-4">
                                <img loading="lazy" decoding="async" alt="" style={{scale: "1"}} src={Comp215} />
                            </div>
                        </div>
                        <div className="Homepage-companies-right-element" style={{ marginBottom: '8px' }} >
                            <div className="Homepage-companies-right-element-5">
                                <img loading="lazy" decoding="async" alt="" style={{scale: "2"}} src={Comp214} />
                            </div>
                            <div className="Homepage-companies-right-element-6">
                                <img loading="lazy" decoding="async" alt="" src={Comp6} />
                            </div>
                        </div>
                        <div className="Homepage-companies-right-element" style={{ marginLeft: '21.6px' }}>
                            <div className="Homepage-companies-right-element-7">
                                <img loading="lazy" decoding="async" alt="" style={{scale: "0.6"}} src={Comp7} />
                            </div>
                            <div className="Homepage-companies-right-element-8">
                                <img loading="lazy" decoding="async" alt="" src={Comp8} />
                            </div>
                        </div>
                        
  </div>
  <div key="back">
    <div className="Homepage-companies-right-element" style={{ marginLeft: '17.4px', marginBottom: '8px' }} >
      <div className="Homepage-companies-right-element-1">
        <img loading="lazy" decoding="async" alt="" style={{scale: "1" }}  src={Comp24}/>
      </div>
      <div className="Homepage-companies-right-element-2">
        <img loading="lazy" decoding="async" alt="" style={{ scale: "1" }} src={Comp29} />
      </div>
    </div>
    <div className="Homepage-companies-right-element" style={{ marginLeft: '45.1px', marginBottom: '8px' }} >
      <div className="Homepage-companies-right-element-3">
        <img loading="lazy" decoding="async" alt="" style={{ scale: "2" }} src={Comp211} />
      </div>
      <div className="Homepage-companies-right-element-4">
        <img loading="lazy" decoding="async" alt="" style={{ scale: "0.6" }} src={Comp27}  />
      </div>
    </div>
    <div className="Homepage-companies-right-element" style={{ marginBottom: '8px' }} >
      <div className="Homepage-companies-right-element-5">
        <img loading="lazy" decoding="async" alt="" style={{ scale: "2" }} src={Comp4}  />
      </div>
      <div className="Homepage-companies-right-element-6">
        <img loading="lazy" decoding="async" alt=""  src={Comp216}/>
      </div>
    </div>
    <div className="Homepage-companies-right-element" style={{ marginLeft: '21.6px' }} >
      <div className="Homepage-companies-right-element-7">
        <img loading="lazy" decoding="async" alt=""  src={Comp22}/>
      </div>
      <div className="Homepage-companies-right-element-8">
        <img loading="lazy" decoding="async" alt=""  style={{maxHeight: "88px", scale: "2.5" }} src={Comp5}  />
      </div>
    </div>
  </div>
</ReactCardFlip>
}</div>

                    <div className='global' >
                       
    <div className="Homepage-companies-right-element" style={{ marginLeft: '17.4px', marginBottom: '8px' }} >
      <div className="Homepage-companies-right-element-1">
        <img loading="lazy" decoding="async" alt=""  src={Comp21} />
      </div>
      <div className="Homepage-companies-right-element-2">
        <img loading="lazy" decoding="async" alt="" style={{ maxHeight: "88px" }}  src={Comp213}/>
      </div>
    </div>
    <div className="Homepage-companies-right-element" style={{ marginLeft: '45.1px', marginBottom: '8px' }} >
      <div className="Homepage-companies-right-element-3">
        <img loading="lazy" decoding="async" alt="" style={{ scale: "0.7" }} src={Comp23} />
      </div>
      <div className="Homepage-companies-right-element-4">
        <img loading="lazy" decoding="async" alt="" style={{ scale: "1.5" }} src={Comp210} />
      </div>
    </div>
    <div className="Homepage-companies-right-element" style={{ marginBottom: '8px' }} >
      <div className="Homepage-companies-right-element-5">
        <img loading="lazy" decoding="async" alt="" style={{ scale: "1" }} src={Comp25} />
      </div>
      <div className="Homepage-companies-right-element-6">
        <img loading="lazy" decoding="async" alt="" src={Comp26} style={{ scale: "1.2", height: '88px' }} />
      </div>
    </div>
    <div className="Homepage-companies-right-element" style={{ marginLeft: '21.6px' }} >
      <div className="Homepage-companies-right-element-7">
        <img loading="lazy" decoding="async" alt="" src={Comp212} />
      </div>
      <div className="Homepage-companies-right-element-8">
        <img loading="lazy" decoding="async" alt="" style={{ maxHeight: "88px" }} src={Comp28} />
      </div>
    </div></div>


                </div>}
                {deviceWidth < 768 && <div ref={scrollContainer} className="Homepage-companies-right">
                    {isLocal && <>
                        <div className="Homepage-companies-right-element">
                            <img loading="lazy" decoding="async" alt="" style={{ height: '40px' }} src={Comp1} />
                        </div>
                        <div className="Homepage-companies-right-element">
                            <img loading="lazy" decoding="async" alt="" style={{ height: '40px' }} src={Comp2} />
                        </div>
                        <div className="Homepage-companies-right-element">
                            <img loading="lazy" decoding="async" alt="" style={{ height: '40px' }} src={Comp3} />
                        </div>
                        
                        <div className="Homepage-companies-right-element">
                            <img loading="lazy" decoding="async" alt="" style={{ height: '40px', scale: '2' }} src={Comp4} />
                        </div>
                        <div className="Homepage-companies-right-element">
                            <img loading="lazy" decoding="async" alt="" style={{ height: '40px', scale: "2.5" }} src={Comp5} />
                        </div>
                        <div className="Homepage-companies-right-element">
                            <img loading="lazy" decoding="async" alt="" style={{ height: '40px' }} src={Comp6} />
                        </div>
                        <div className="Homepage-companies-right-element">
                            <img loading="lazy" decoding="async" alt="" style={{ height: '40px' }} src={Comp7} />
                        </div>
                        <div className="Homepage-companies-right-element">
                            <img loading="lazy" decoding="async" alt="" style={{ height: '40px' }} src={Comp8} />
                        </div>
                        
                        <div className="Homepage-companies-right-element">
                            <img loading="lazy" decoding="async" alt="" style={{ height: '40px' }} src={Comp24} />
                        </div>
                        <div className="Homepage-companies-right-element">
                            <img loading="lazy" decoding="async" alt="" style={{ height: '40px' }} src={Comp29}/>
                        </div>
                        <div className="Homepage-companies-right-element">
                            <img loading="lazy" decoding="async" alt="" style={{ height: '40px', scale: '1.5' }} src={Comp211}/>
                        </div>
                        <div className="Homepage-companies-right-element">
                            <img loading="lazy" decoding="async" alt="" style={{ height: '40px' }} src={Comp214} />
                        </div>
                        <div className="Homepage-companies-right-element">
                            <img loading="lazy" decoding="async" alt="" style={{ height: '40px' }} src={Comp216} />
                        </div>
                        
                        <div className="Homepage-companies-right-element">
                            <img loading="lazy" decoding="async" alt="" style={{ height: '40px' }} src={Comp27} />
                        </div>
                        
                        <div className="Homepage-companies-right-element">
                            <img loading="lazy" decoding="async" alt="" style={{ height: '40px' }} src={Comp22} />
                        </div>
                        
                        <div className="Homepage-companies-right-element">
                            <img loading="lazy" decoding="async" alt="" style={{ height: '40px' }} src={Comp215} />
                        </div>
                    </>}
                    {!isLocal && <>
                        <div className="Homepage-companies-right-element">
                            <img loading="lazy" decoding="async" alt="" style={{ height: '40px' }} src={Comp21}/>
                        </div>
                        <div className="Homepage-companies-right-element">
                            <img loading="lazy" decoding="async" alt="" style={{ height: '40px' }} src={Comp213}/>
                        </div>
                        <div className="Homepage-companies-right-element">
                            <img loading="lazy" decoding="async" alt="" style={{ height: '40px' }} src={Comp23}/>
                        </div>
                        <div className="Homepage-companies-right-element">
                            <img loading="lazy" decoding="async" alt="" style={{ height: '40px' }} src={Comp210} />
                        </div>
                        <div className="Homepage-companies-right-element">
                            <img loading="lazy" decoding="async" alt="" style={{ height: '40px' }} src={Comp25} />
                        </div>
                        <div className="Homepage-companies-right-element">
                            <img loading="lazy" decoding="async" alt="" style={{ height: '40px' }} src={Comp26} />
                        </div>
                        <div className="Homepage-companies-right-element">
                            <img loading="lazy" decoding="async" alt="" style={{ height: '40px' }} src={Comp212} />
                        </div>
                        <div className="Homepage-companies-right-element">
                            <img loading="lazy" decoding="async" alt="" style={{ height: '40px' }} src={Comp28} />
                        </div>
                        
                    </>}
                </div>
                }
            </section>
            {/* Break */}
            <div className="Homepage-news">
                <div className="Homepage-news-top">
                    <p className="Homepage-news-top-left">{t('News1')}</p>
                    <Link to="/news">
                        <div className="Homepage-news-top-right">
                            <p className="Homepage-news-top-right-text">{t('News2')}</p>
                            <img loading="lazy" decoding="async" alt="" src={Chevron} className="Homepage-news-top-right-icon" />
                        </div></Link>
                </div>
                <div className="Homepage-news-bottom">
                <Link to='/article1'>
                        <div className="Homepage-news-bottom-element">
                            <img loading="lazy" decoding="async" alt="" src={Post1} className="Homepage-news-bottom-element-image" />
                            <div className="Homepage-news-bottom-element-content">
                                <div className="Homepage-news-bottom-element-content-top">
                                  
                                    <p className="Homepage-news-bottom-element-content-top-text2">Sharing with you some photos from our latest seminar! It was a wonderful day filled with knowledge exchange and valuable connections. Thanks to everyone who</p>
                                </div>
                                <div className="Homepage-news-bottom-element-content-bottom">
                                    <p className="Homepage-news-bottom-element-content-bottom-text">Mar 6,2024</p>
                                </div>
                            </div>
                        </div></Link>
                    <Link to='/article2'>
                        <div className="Homepage-news-bottom-element">
                            <img loading="lazy" decoding="async" alt="" src={Post2} className="Homepage-news-bottom-element-image" />
                            <div className="Homepage-news-bottom-element-content">
                                <div className="Homepage-news-bottom-element-content-top">
                                   
                                    <p className="Homepage-news-bottom-element-content-top-text2">On March 5th, Khamsa Insurance and Reinsurance Brokers LLC, with the support of the Azerbaijan Banks Association and the British Chamber of Commerce Azerbaijan (BCCA), hosted a seminar titled "Secure the Boundaries" focusing on "Cyber Insurance and Directors and Officers (D&O) Insurance." </p>
                                </div>
                                <div className="Homepage-news-bottom-element-content-bottom">
                                    <p className="Homepage-news-bottom-element-content-bottom-text">Mar 6,2024</p>
                                </div>
                            </div>
                        </div></Link>
                        <Link to='/article3' >
                        <div className="Homepage-news-bottom-element">
                            <img loading="lazy" decoding="async" alt="" src={Post3} className="Homepage-news-bottom-element-image" />
                            <div className="Homepage-news-bottom-element-content">
                                <div className="Homepage-news-bottom-element-content-top">
                                  
                                    <p className="Homepage-news-bottom-element-content-top-text2">Dear Partners,
On 29 January, Khamsa Insurance and Reinsurance Brokers held an important event on "Safe Steps to Foundation in Post-Conflict Areas" at the initiative of the Central Bank of the Republic of Azerbaijan and with support of the Azerbaijan Insurers</p>
                                </div>
                                <div className="Homepage-news-bottom-element-content-bottom">
                                    <p className="Homepage-news-bottom-element-content-bottom-text">Jan 30,2024</p>
                                </div>
                            </div>
                        </div></Link>
                    
                    {(deviceWidth < 1024 && deviceWidth > 767) &&
                        <Link to='/article'>
                            <div className="Homepage-news-bottom-element">
                                <img loading="lazy" decoding="async" alt="" src={Img3} className="Homepage-news-bottom-element-image" />
                                <div className="Homepage-news-bottom-element-content">
                                    <div className="Homepage-news-bottom-element-content-top">
                                      {/* <p className="Homepage-news-bottom-element-content-top-text1">5 key generative AI use cases in insurance distribution</p>*/}
                                        <p className="Homepage-news-bottom-element-content-top-text2">With lots of unique blocks, you can easily build a page without coding. Build your next landing page.</p>
                                    </div>
                                    <div className="Homepage-news-bottom-element-content-bottom">
                                        <p className="Homepage-news-bottom-element-content-bottom-text">Aug 19,2024</p>
                                    </div>
                                </div>
                            </div></Link>
                    }
                </div>
            </div>
            {/* Break */}

            <div className="Homepage-quote">
                <img loading="lazy" decoding="async" src={QuoteBackground} className='quote-background' alt="" />

                <div className={`quote-container Homepage-quote__inner ${animationClass}`}>
                   <div  style={{display: "flex", flexDirection: "row"}}> 
                        <img loading="lazy" decoding="async" src={QuoteSymbol} className='quote-symbol-1' alt="" />
                        <h2>{t(currentQuote.quoteKey)}</h2>        
                        <img loading="lazy" decoding="async" src={QuoteSymbol} className='quote-symbol-2' alt="" />
                    </div>
                    <h3 style={{color: "white"}}>{t(currentQuote.authorKey)}</h3>
                </div>
            </div>
            {/* Break */}
            <Footer />
        </m.div>
    )
}

export default Homepage